export class HomeButton {
  icon: string;
  link: string;
}
